import React from 'react';

import { useIntl } from 'react-intl';

// Per-component subpath: the `@atlaskit/primitives/compiled` barrel is a fully
// deprecated entry point and new imports from it fail the ratcheting check.
import { Inline } from '@atlaskit/primitives/compiled/inline';

import { RefreshedFilterButtonContext } from '../../../../../common/ui/filters/filter-button/refreshed-filter-button-context';
import { shouldShowRefreshedFilterRow } from '../../../../../common/utils/experiments';
import { usePrimaryProduct } from '../../../../../controllers/store/bootstrap';
import { useSelectedProduct } from '../../../../../controllers/store/search';
import { filters } from '../../product-filters';
import { useRefreshFilterPlacement } from '../use-filter-placement';
import { messages } from './messages';

export const InlineFilters = (): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const [primaryProduct] = usePrimaryProduct();
	const [selectedProduct] = useSelectedProduct();
	const { filtersInLine } = useRefreshFilterPlacement();

	if (!shouldShowRefreshedFilterRow(primaryProduct) || filtersInLine.length === 0) {
		return null;
	}

	return (
		<RefreshedFilterButtonContext.Provider value>
			<Inline
				space="space.050"
				alignBlock="center"
				role="group"
				aria-label={formatMessage(messages.groupLabel)}
				testId="search-page-refresh-filter-row-inline-filters"
			>
				{filtersInLine.map((id) => {
					const Filter = filters[id as keyof typeof filters];
					if (!Filter) {
						return null;
					}

					// "All apps" shows the primary product's filters, so name the app they belong to.
					return <Filter key={id} fit="compact" showPrimaryProductIcon={!selectedProduct} />;
				})}
			</Inline>
		</RefreshedFilterButtonContext.Provider>
	);
};
